/**
 * FieldRow — eine Zeile im Termin-Block: kleine Beschriftung, darunter der
 * Wert.
 *
 * Sorgt dafür, dass feste Angaben (Datum, Raum) und Auswahlfelder (Standort,
 * Gastgeber) gleich aufgebaut sind — nur das Innere unterscheidet sich.
 */
export function FieldRow({ label, children }) {
  return (
    <div>
      <span className="block text-[1.1rem] font-semibold text-dim mb-[0.4rem]">
        {label}
      </span>
      {children}
    </div>
  );
}

/** Fester, nicht bearbeitbarer Wert innerhalb einer `FieldRow`. */
export function FieldValue({ children }) {
  return <span className="block text-[1.3rem] text-foreground">{children}</span>;
}
